"use strict";
(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[6556],{

/***/ 45600:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78364);



const fitToClassName = {
    "cover": "object-cover",
    "contain": "object-contain"
};
// It helps to create placeholders for images
const AspectContainer = (props)=>{
    const { children, className, aspect = 1, fit = "cover", "data-testid": dataTestId } = props;
    const placeholderStyle = {
        paddingTop: `${Math.round(100 / aspect)}%`
    };
    const childClassName = (0,classnames__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("absolute left-0 top-0 h-full w-full", children.props.className, fitToClassName[fit]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,classnames__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(className, !(className === null || className === void 0 ? void 0 : className.includes("absolute")) && "relative"),
        "data-testid": dataTestId,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                style: placeholderStyle
            }),
            /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.cloneElement(children, {
                className: childClassName
            })
        ]
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (AspectContainer);


/***/ }),

/***/ 29564:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ Bone_Bone)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
;// CONCATENATED MODULE: ./src/components/layout/Bone/Bone.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const Bone_module = ({"skeleton":"UG_B9X","shine-lines":"VCj7Eb"});
;// CONCATENATED MODULE: ./src/components/layout/Bone/Bone.tsx




const Bone = (props)=>{
    const { className, w: width, h: height, pw: percentWidth, ph: percentHeight, aspect, circle, inline = false, bgColor = "gray-20" } = props;
    const style = (0,react.useMemo)(()=>{
        const style = {};
        if (width) {
            style.width = style.minWidth = `${width}rem`;
        }
        if (percentWidth) {
            style.width = style.minWidth = `${percentWidth}%`;
        }
        if (height) {
            style.height = style.minHeight = `${height}rem`;
        }
        if (percentHeight) {
            style.height = style.minHeight = `${percentHeight}%`;
        }
        return style;
    }, [
        width,
        height,
        percentWidth,
        percentHeight
    ]);
    const skeletonClassName = (0,clsx/* default */.Z)("relative overflow-hidden", Bone_module.skeleton, className, {
        "inline-block": inline,
        "rounded-full": circle,
        [`bg-${bgColor}`]: bgColor
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: skeletonClassName,
        style: style,
        children: aspect && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            style: {
                paddingTop: `${Math.round(100 / aspect)}%`
            }
        })
    });
};
/* harmony default export */ const Bone_Bone = (/*#__PURE__*/react.memo(Bone));


/***/ }),

/***/ 31937:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export colorToClassName */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78364);



const colorToClassName = {
    "gray-30": "text-gray-30",
    "gold-50": "text-gold-50"
};
const Divider = (props)=>{
    const { className, color = "gray-30" } = props;
    const rootClassName = (0,classnames__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("h-1 bg-[currentColor]", colorToClassName[color], className);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: rootClassName
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Divider);


/***/ }),

/***/ 19515:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  ZP: () => (/* binding */ Grid_Grid)
});

// UNUSED EXPORTS: aligns, columnsSizes, gutterSizes, justifies

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
;// CONCATENATED MODULE: ./src/components/layout/Grid/Cell/Cell.tsx


const Cell = (props)=>{
    let { children, className, tag = "div", size = 1, tabIndex, "aria-labelledby": ariaLabelledby } = props;
    const rootClassName = (0,clsx/* default */.Z)(className, "mouse-focus:outline-none", {
        [`col-span-${size}`]: Number(size) > 1
    });
    const nodeProps = {
        className: rootClassName,
        tabIndex,
        role: "listitem",
        "aria-labelledby": ariaLabelledby
    };
    return /*#__PURE__*/ react.createElement(tag, nodeProps, children);
};
/* harmony default export */ const Cell_Cell = (Cell);

;// CONCATENATED MODULE: ./src/components/layout/Grid/Grid.tsx




const aligns = (/* unused pure expression or super */ null && ([
    "center",
    "start",
    "end",
    "baseline",
    "stretch"
]));
const justifies = (/* unused pure expression or super */ null && ([
    "between",
    "center",
    "start",
    "end"
]));
const columnsSizes = (/* unused pure expression or super */ null && ([
    1,
    2,
    3,
    4,
    5,
    6,
    "2-center",
    "3-center",
    "6-center"
]));
const gutterSizes = (/* unused pure expression or super */ null && ([
    8,
    12,
    16,
    24,
    32
]));
const Grid = (props)=>{
    const { children, className, columns = 1, gutter, align = "start", justify = "start", role = "list", noWrap, "data-testid": dataTestId, dataAttributes } = props;
    const rootClassName = (0,clsx/* default */.Z)(className, "grid", {
        "grid-flow-col": noWrap,
        [`items-${align}`]: align,
        [`grid-cols-${columns}`]: columns,
        [`justify-${justify}`]: justify,
        [`gap-${gutter}`]: gutter
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: rootClassName,
        role: role,
        "data-testid": dataTestId,
        ...dataAttributes,
        children: children
    });
};
Grid.Cell = Cell_Cell;
/* harmony default export */ const Grid_Grid = (Grid);


/***/ }),

/***/ 30389:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ Overlay_Overlay)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
;// CONCATENATED MODULE: ./src/components/layout/Overlay/Overlay.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const Overlay_module = ({"overlay":"tLVDDZ","openOverlay":"S8968W","mounted":"_pY0DF"});
;// CONCATENATED MODULE: ./src/components/layout/Overlay/Overlay.tsx




const Overlay = (param)=>{
    let { children, className, onClick } = param;
    const ref = (0,react.useRef)();
    (0,react.useEffect)(()=>{
        // ATTN this workaround required to fix transition animation glitch (elements jumping from top to down when moving)
        //  timeout means that animation is finished
        const timer = setTimeout(()=>{
            if (ref.current) {
                ref.current.classList.add(Overlay_module.mounted);
            }
        }, 400);
        return ()=>{
            clearTimeout(timer);
        };
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: ref,
        className: (0,clsx/* default */.Z)(Overlay_module.overlay, "inset-0", className),
        onClick: onClick,
        children: children
    });
};
/* harmony default export */ const Overlay_Overlay = (Overlay);


/***/ }),

/***/ 7794:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78364);
/* harmony import */ var device__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96934);




const PageLayout = (props)=>{
    const { children, className, withPaddingTop = true, withPaddingBottom = true } = props;
    const { isMobile } = (0,device__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    const topClassName = isMobile ? "pt-40" : "pt-48";
    const bottomClassName = isMobile ? "pb-64" : "pb-80";
    const rootClassName = (0,classnames__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(className, {
        [topClassName]: withPaddingTop,
        [bottomClassName]: withPaddingBottom
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: rootClassName,
        children: children
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (PageLayout);


/***/ }),

/***/ 90076:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78364);
/* harmony import */ var device__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96934);




const ScrollableContainer = (props)=>{
    const { children, className, isDesktopEnabled = false } = props;
    const { isMobile } = (0,device__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    const containerClassName = (0,classnames__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(className, isMobile && "-mx-16 touch-manipulation px-16", (isMobile || isDesktopEnabled) && "no-scrollbar overflow-x-auto overflow-y-hidden");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: containerClassName,
        children: children
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ScrollableContainer);


/***/ }),

/***/ 41067:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ SideBySideLayout_SideBySideLayout)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./src/components/layout/WidthContainer/WidthContainer.tsx
var WidthContainer = __webpack_require__(59343);
;// CONCATENATED MODULE: ./src/components/layout/SideBySideLayout/SideBySideLayout.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const SideBySideLayout_module = ({"container":"i5hgvu"});
;// CONCATENATED MODULE: ./src/components/layout/SideBySideLayout/SideBySideLayout.tsx





const SideBySideLayout = (props)=>{
    const { className, children } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(WidthContainer/* default */.Z, {
        className: (0,clsx/* default */.Z)(className, SideBySideLayout_module.container),
        children: children
    });
};
/* harmony default export */ const SideBySideLayout_SideBySideLayout = (SideBySideLayout);


/***/ }),

/***/ 63295:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ StickyFooterContainer_StickyFooterContainer)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
;// CONCATENATED MODULE: ./src/components/layout/StickyFooterContainer/StickyFooterContainer.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const StickyFooterContainer_module = ({"root":"xFFca1","top":"be2u4G","bottom":"bCLoLZ","visible":"GqqATU"});
;// CONCATENATED MODULE: ./src/components/layout/StickyFooterContainer/StickyFooterContainer.tsx




const StickyFooterContainer = (props)=>{
    const { children, className, bgColor = "bg-gold-30", position = "bottom", isVisible = true, "data-testid": dataTestId } = props;
    const rootClassName = (0,clsx/* default */.Z)(className, bgColor, StickyFooterContainer_module.root, isVisible && StickyFooterContainer_module.visible, "fixed inset-x-0 z-floating-header", position === "top" ? "top-0" : "bottom-0", StickyFooterContainer_module[position]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: rootClassName,
        "data-testid": dataTestId,
        children: children
    });
};
/* harmony default export */ const StickyFooterContainer_StickyFooterContainer = (StickyFooterContainer);


/***/ }),

/***/ 64710:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var react_helmet_async__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75479);



const htmlAttributes = {
    // @ts-ignore there is an error in typings of Helmet
    style: "background-color:#fff"
};
const WhitePageLayout = (param)=>{
    let { children } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_helmet_async__WEBPACK_IMPORTED_MODULE_2__/* .Helmet */ .ql, {
                htmlAttributes: htmlAttributes
            }),
            children
        ]
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (WhitePageLayout);


/***/ }),

/***/ 59343:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78364);



const WidthContainer = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)((props, ref)=>{
    const { children, id, className, ignore, size = 1136, style, "data-testid": dataTestId, dataAttributes } = props;
    const rootClassName = (0,classnames__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(className, {
        "px-16 mx-auto": !ignore,
        "max-w-1440": !ignore && size === 1440,
        "max-w-1312": !ignore && size === 1312,
        "max-w-1168": !ignore && size === 1136,
        "max-w-976": !ignore && size === 944
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        ref: ref,
        id: id,
        className: rootClassName,
        style: style,
        "data-testid": dataTestId,
        ...dataAttributes,
        children: children
    });
});
WidthContainer.displayName = "WidthContainer";
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (WidthContainer);


/***/ }),

/***/ 46907:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78364);



const WidthContainerCompensator = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)((props, ref)=>{
    const { className, children, "data-testid": dataTestId } = props;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        ref: ref,
        className: (0,classnames__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(className, "-mx-16"),
        "data-testid": dataTestId,
        children: children
    });
});
WidthContainerCompensator.displayName = "WidthContainerCompensator";
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (WidthContainerCompensator);


/***/ })

}]);